module.exports = __webpack_public_path__ + "static/img/brees-2006-slide-2.acabfa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-slide-2.jpg
// module id = ITSE
// module chunks = 1